<template>
    <div
        class="empty-chat-wrapper d-flex h-100 justify-content-center align-items-center"
        :class="{ 'has-wallpaper-image': hasWallpaperImage }"
        :style="{ '--chat-wallpaper-image': wallpaperImageVar }"
    >
        <div class="text-center">
            <img :src="currentImage" class="empty-image" :alt="branding.companyName">
            
            <h4 class="empty-title">{{ currentTitle }}</h4>
            
            <p class="empty-text">
                {{ currentText }}
            </p>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useChatStore } from '@/stores/app/chatStore';
import { branding } from '@/config/branding';

const chatStore = useChatStore();

const isTeamMode = computed(() => chatStore.isTeamMode);

const currentImage = computed(() => {
    return isTeamMode.value ? branding.images.emptyChatTeam : branding.images.emptyChat;
});

const currentTitle = computed(() => {
    return isTeamMode.value ? 'Chat Interno' : branding.texts.welcomeChatTitle;
});

const currentText = computed(() => {
    if (isTeamMode.value) {
        return 'Conecte-se com sua equipe de forma rápida e segura. Selecione um colaborador ao lado para iniciar uma conversa interna.';
    }
    return branding.texts.welcomeChatText;
});

const hasWallpaperImage = computed(() => !!branding.images.chatWallpaper);

const wallpaperImageVar = computed(() => {
    return branding.images.chatWallpaper ? `url('${branding.images.chatWallpaper}')` : 'none';
});
</script>

<style scoped>
.empty-chat-wrapper {
    background-color: transparent;
    position: relative;

    background-repeat: repeat;
    background-position: center;
    background-size: 500px auto;
    background-attachment: fixed;
}

.empty-chat-wrapper.has-wallpaper-image {
    background-image: var(--chat-wallpaper-image, none);
}

.empty-chat-wrapper:not(.has-wallpaper-image) {
    background-image: radial-gradient(circle, rgba(var(--bs-primary-rgb), 0.05) 1.5px, transparent 1.5px);
    background-size: 24px 24px;
    background-attachment: fixed;
}

.empty-chat-wrapper::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
}
[data-bs-theme=light] .empty-chat-wrapper::before {
    background-color: rgba(255, 255, 255, 0.6);
}
[data-bs-theme=dark] .empty-chat-wrapper::before {
    background-color: rgba(54, 54, 54, 0.138);
}

.text-center {
    position: relative;
    z-index: 1;
    padding: 0 20px;
}

.empty-image {
    margin-bottom: 24px; 
    width: 250px;
    transition: all 0.3s ease;
}

.empty-title {
    font-size: 22px;
    font-weight: 600;
    color: var(--bs-dark);
    margin-bottom: 12px;
}

.empty-text {
    margin: 0 auto;
    font-size: 15px; 
    color: var(--bs-text-muted);
    max-width: 450px; 
    line-height: 1.6;
}
</style>